module.exports = __webpack_public_path__ + "img/account.9f72c13b.svg";